/**
 * Timesheet Reference Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String}
 */
window.timesheetReferenceFormatter = function(value, row) {
    let html = '';
    if (value === null) {
        return html;
    }
    let a = value.split(",");
    for (let i = 0; i < a.length; i++) {
        html += '<span class="badge badge-pill badge-reference" style="margin-right: 6px">';
        if (typeof row.reference_url !== "undefined"
        && row.reference_url !== null
        && a[i].includes(row.code)) {
            html += '<a href="'+row.reference_url+a[i]+'" target="_blank" rel="nofollow">';
            html += a[i];
            html += '</a>';
        } else {
            html += a[i];
        }
        html += '</span>';
    }
    return html;
};
